import React, { useState } from "react";
import "./style.css";
import { FaCalendar } from "react-icons/fa";
import { Button } from "react-bootstrap";

const EventLineDrawer = ({
  onClose,
  onSubmit,
  handleDrawClick,
  useCaseId,
  setUseCaseId,
  restrictedSide,
  setRestrictedSide,
  useCaseList,
  lineOrientation,
  showDirectionSelect,
  setShowDirectionSelect,
  name,
  setName,
  drawMode, // <-- add this
  currentLine, // <-- add this
  handleCompletePolygon, // <-- add this
}) => {
  // const [name, setName] = useState("Office Entrance Line");
  const [eventType, setEventType] = useState("Line Cross");
  const [direction, setDirection] = useState(restrictedSide || "both");

  const handleSubmit = () => {
    onSubmit({
      name,
      eventType,
      direction,
      useCaseId, // Pass this back too
      restrictedSide: direction,
    });
  };

  return (
    <div className="event-drawer">
      <div className="event-header">
        <span>
          <FaCalendar /> Events
        </span>
        <button onClick={onClose}>✕</button>
      </div>

      <div className="event-body">
        <label>Name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />

        <label>Event Type</label>
        <select
          value={eventType}
          onChange={(e) => setEventType(e.target.value)}
        >
          <option value="Line Cross">Line Cross</option>
          <option value="polygon">Polygon</option>
        </select>

        <label>Counting Direction</label>
        <div className="direction-options">
          <span
            className={`dir-icon ${direction === "in" ? "selected" : ""}`}
            onClick={() => setDirection("in")}
            title="In"
          >
            🔴
          </span>
          <span
            className={`dir-icon ${direction === "both" ? "selected" : ""}`}
            onClick={() => setDirection("both")}
            title="Both"
          >
            ⇄
          </span>
          <span
            className={`dir-icon ${direction === "out" ? "selected" : ""}`}
            onClick={() => setDirection("out")}
            title="Out"
          >
            🟢
          </span>
        </div>

        {eventType === "Line Cross" && (
          <button className="draw-btn" onClick={() => handleDrawClick("line")}>
            🔧 Click to draw line on video
          </button>
        )}
        {eventType === "polygon" && (
          <button
            className="draw-btn"
            onClick={() => handleDrawClick("polygon")}
          >
            🔺 Click to draw polygon on video
          </button>
        )}

        <label className="form-label">UseCase</label>
        <select
          name="use_case"
          className="form-select"
          value={useCaseId}
          onChange={(e) => setUseCaseId(e.target.value)}
        >
          <option value="">Select</option>
          {useCaseList.map((ele) => (
            <option key={ele._id} value={ele._id}>
              {ele.usecase_name}
            </option>
          ))}
        </select>
        {showDirectionSelect && (
          <div className="direction-popup">
            <label htmlFor="direction">Select Restricted Side</label>
            <select
              id="direction"
              onChange={(e) => {
                setRestrictedSide(e.target.value);
                setShowDirectionSelect(false); // Optional: close after selecting
              }}
              defaultValue=""
            >
              <option value="" disabled>
                Choose direction
              </option>
              {lineOrientation === "horizontal" ? (
                <>
                  <option value="top">Top</option>
                  <option value="bottom">Bottom</option>
                  <option value="both">Both Sides</option>
                </>
              ) : (
                <>
                  <option value="left">Left</option>
                  <option value="right">Right</option>
                </>
              )}
            </select>
          </div>
        )}
      </div>

      <div className="event-footer">
        <button className="cancel-btn" onClick={onClose}>
          Cancel
        </button>
        {drawMode === "polygon" && currentLine.length >= 3 ? (
          <>
            <button className="action-btn" onClick={handleCompletePolygon}>
              Complete Polygon
            </button>
          </>
        ) : (
          <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        )}
      </div>
    </div>
  );
};

export default EventLineDrawer;
